import { render, staticRenderFns } from "./unlicensed.vue?vue&type=template&id=24ed86a2&scoped=true&"
import script from "./unlicensed.vue?vue&type=script&lang=js&"
export * from "./unlicensed.vue?vue&type=script&lang=js&"
import style0 from "./unlicensed.vue?vue&type=style&index=0&id=24ed86a2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ed86a2",
  null
  
)

component.options.__file = "unlicensed.vue"
export default component.exports